module.exports = __webpack_public_path__ + "static/media/geometria-light-webfont.d282bb5e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/geometria-light-webfont.woff
// module id = 78
// module chunks = 0